module.exports = __webpack_public_path__ + "img/Web_reporter.22b07a37.png";